module.exports = __webpack_public_path__ + "img/odeon_logo.93ac7bed.png";